const GET_AZURE_MONITOR_STORAGE_ACCOUNT = "GET_AZURE_MONITOR_STORAGE_ACCOUNT";
const GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS =
  "GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS";
const GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR =
  "GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR";

// const GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES =
//   "GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES";
// const GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS =
//   "GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS";
// const GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR =
//   "GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR";

export {
  GET_AZURE_MONITOR_STORAGE_ACCOUNT,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_SUCCESS,
  GET_AZURE_MONITOR_STORAGE_ACCOUNT_ERROR,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_SUCCESS,
  // GET_AZURE_MONITOR_APPLICATION_RESOURCE_NAMES_ERROR,
};
